import { render, staticRenderFns } from "./projectInfo.vue?vue&type=template&id=0a16bd04&scoped=true&"
import script from "./projectInfo.vue?vue&type=script&lang=js&"
export * from "./projectInfo.vue?vue&type=script&lang=js&"
import style0 from "./projectInfo.vue?vue&type=style&index=0&id=0a16bd04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a16bd04",
  null
  
)

export default component.exports